"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modem = exports.decodeModem = void 0;

function decodeModem(m) {
  var identifiersDownloadedAt = new Date();

  if (m.identifiersDownloadedAt) {
    identifiersDownloadedAt = new Date(m.identifiersDownloadedAt);
  }

  var statusDownloadedAt = new Date();

  if (m.statusDownloadedAt) {
    statusDownloadedAt = new Date(m.statusDownloadedAt);
  }

  return new Modem(m.imei, m.iccid, m.rssi, m.ber, m.operator, m.antennaType, identifiersDownloadedAt, statusDownloadedAt);
}

exports.decodeModem = decodeModem;

var Modem =
/** @class */
function () {
  function Modem(imei, iccid, rssi, ber, operator, antennaType, identifiersDownloadedAt, statusDownloadedAt) {
    if (imei === void 0) {
      imei = '';
    }

    if (iccid === void 0) {
      iccid = '';
    }

    if (rssi === void 0) {
      rssi = 0;
    }

    if (ber === void 0) {
      ber = 0;
    }

    if (operator === void 0) {
      operator = '';
    }

    if (antennaType === void 0) {
      antennaType = 0;
    }

    if (identifiersDownloadedAt === void 0) {
      identifiersDownloadedAt = new Date(0);
    }

    if (statusDownloadedAt === void 0) {
      statusDownloadedAt = new Date(0);
    }

    this.imei = imei;
    this.iccid = iccid;
    this.rssi = rssi;
    this.ber = ber;
    this.operator = operator;
    this.antennaType = antennaType;
    this.identifiersDownloadedAt = identifiersDownloadedAt;
    this.statusDownloadedAt = statusDownloadedAt;
  }

  Modem.prototype.signalOK = function () {
    return this.rssi > -105;
  };

  Modem.prototype.rssiToPercent = function () {
    if (this.rssi) {
      // return (this.rssi>-53) ? 100 : (this.rssi<-200) ? 0 :
      // (1-((Math.abs(this.rssi)-53)/(120-53)))*100;
      if (this.rssi > -64) {
        return 100;
      }

      if (this.rssi > -74) {
        return 83;
      }

      if (this.rssi > -84) {
        return 66;
      }

      if (this.rssi > -94) {
        return 50;
      }

      if (this.rssi > -98) {
        return 33;
      }

      if (this.rssi > -104) {
        return 16;
      }

      if (this.rssi < -107) {
        return 1;
      }
    }

    return 0;
  };

  Modem.prototype.encode = function () {
    var rawModem = {};

    if (this.imei != null && this.imei.length > 0) {
      rawModem["imei"] = this.imei;
    }

    if (this.iccid != null && this.iccid.length > 0) {
      rawModem["iccid"] = this.iccid;
    }

    if (this.rssi !== 0) {
      rawModem["rssi"] = this.rssi;
    }

    if (this.ber !== 0) {
      rawModem["ber"] = this.ber;
    }

    if (this.operator != null && this.operator.length > 0) {
      rawModem["operator"] = this.operator;
    }

    if (this.antennaType !== 0) {
      rawModem["antennaType"] = this.antennaType;
    }

    if (this.identifiersDownloadedAt.getTime() !== 0) {
      rawModem["identifiersDownloadedAt"] = this.identifiersDownloadedAt;
    }

    if (this.statusDownloadedAt.getTime() !== 0) {
      rawModem["statusDownloadedAt"] = this.statusDownloadedAt;
    }

    return rawModem;
  };

  return Modem;
}();

exports.Modem = Modem;
exports.default = Modem;